import { Routes, Route, useNavigate, Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { MainLayout } from '@/shared/components/layout'
import { useAuth } from '@/shared/contexts/AuthContext'
import { useUnit } from '@/modules/units/contexts/UnitContext'
// import { PricingProvider } from '@/contexts/PricingContext'
import { getProfile } from '@/modules/profile'
import { getUserUnitsByContext } from '@/modules/units'
import { Products } from '@/modules/pricing/products'
import { PricingMaterials } from '@/modules/pricing/materials'
// import { PricingSaleSimulator } from '@/pages/registrations/pricing/SaleSimulatorPage'
// import { PricingFixedCosts } from '@/pages/pricing/FixedCostsPage'

export default function PricingLayout() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const { currentUnit, isLoading: unitLoading, setCurrentUnit: switchUnit } = useUnit()
  const [profile, setProfile] = useState<any | null>(null)
  const [resolving, setResolving] = useState(false)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (!user?.id) return
    getProfile(user.id)
      .then(setProfile)
      .catch((err) => console.error('Error loading profile in PricingLayout', err))
  }, [user?.id])

  useEffect(() => {
    if (!user?.id) return
    if (unitLoading || resolving) return

    // Current unit already belongs to pricing — all good
    if (currentUnit?.context_key === 'pricing') {
      setReady(true)
      return
    }

    // Current unit is missing or belongs to another context.
    // Look for any pricing unit the user owns and switch to it.
    const resolve = async () => {
      setResolving(true)
      try {
        const pricingUnits = await getUserUnitsByContext(user.id, 'pricing')
        if (pricingUnits.length > 0) {
          // Switch current unit to the first pricing unit found
          await switchUnit(pricingUnits[0].id)
          setReady(true)
        } else {
          navigate('/onboarding', { replace: true })
        }
      } catch (err) {
        console.error('[PricingLayout] Error resolving pricing unit:', err)
        navigate('/onboarding', { replace: true })
      } finally {
        setResolving(false)
      }
    }

    resolve()
  }, [user?.id, unitLoading, currentUnit])

  if (unitLoading || resolving || !ready) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50 dark:bg-gray-950">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-green-600 border-r-transparent" />
      </div>
    )
  }

  // return (
  //   <MainLayout
  //     userName={profile?.full_name || user?.email}
  //     userId={user?.id}
  //     currentUnitId={profile?.current_unit_id || null}
  //   >
  //     <PricingProvider>
  //       <Routes>
  //         <Route path="produtos" element={<Products />} />
  //         <Route path="produto" element={<Products />} />
  //         <Route path="insumos" element={<PricingMaterials />} />
  //         <Route path="simulador" element={<PricingSaleSimulator />} /> 
  //         <Route path="custos-fixos" element={<PricingFixedCosts />} /> 
  //         <Route index element={<Navigate to="produtos" replace />} />
  //       </Routes>
  //     </PricingProvider>
  //   </MainLayout>
  // )
}
